const initialState = {
  loading: false,
  error: null,
  fields: {},
  emailStatus: null,
  fieldErrors: {},
  fieldWarnings: {},
  isInitialCaptchaSet: false,
  resendActivationEmailSuccess: false,
  passwordRecoverSuccess: false,
  requestTOTP: false,
  totpSessionChallenge: null,
  loginCaptcha: {
    captchaType: null,
    cgcaptcha: {
      id: '',
      imageUrl: '',
      loading: false,
    },
  },
  RequiredPasswordUpdate: false,
  RequiredProfileUpdate: false,
};

export default function (state = initialState, payload) {
  switch (payload.type) {
    case 'TRIAL_INPUT_CHANGE':
      return {
        ...state,
        fields: {
          ...state.fields,
          ...payload.data,
        },
      };
    case 'TRIAL_POPULATE_COUNTRIES':
      return {
        ...state,
        countries: payload.data.countries,
        fields: {
          ...state.fields,
          countryCode: payload.data.location,
        },
      };
    case 'TRIAL_SET_LOADING':
      return {
        ...state,
        loading: payload.loading,
      };
    case 'TRIAL_SET_EMAIL_STATUS':
      return { ...state, emailStatus: payload.status };
    case 'SUBMIT_REGISTER':
      return { ...state, loading: true };
    case 'TRIAL_SET_IS_INITIAL_CAPTCHA_SET':
      return { ...state, isInitialCaptchaSet: payload.isInitialCaptchaSet };
    case 'TRIAL_SUBMIT_REGISTER#ERROR':
      return { ...state, error: payload.data.error, fieldErrors: {}, loading: false };
    case 'TRIAL_SUBMIT_REGISTER#VALIDATION_ERROR':
      return { ...state, error: payload.error || null, fieldErrors: payload.data.fieldErrors, loading: false };
    case 'TRIAL_RESEND_ACTIVATION_EMAIL#SUCCESS':
      return { ...state, resendActivationEmailSuccess: true };
    case 'TRIAL_PASSWORD_RECOVER#SUCCESS':
      return { ...state, passwordRecoverSuccess: true, fieldErrors: {} };
    case 'TRIAL_PASSWORD_RECOVER#RESET':
      return { ...state, passwordRecoverSuccess: false };
    case 'TRIAL_ERROR':
      return {
        ...state,
        fieldErrors: {
          ...state.fieldErrors,
          ...(payload.fieldErrors || {}),
        },
        error: payload.error || state.error,
        loading: false,
      };
    case 'GENERATE_TRIAL_LOGIN_CG_CAPTCHA#START':
      return {
        ...state,
        loginCaptcha: {
          ...state.loginCaptcha,
          cgcaptcha: {
            ...state.loginCaptcha.cgcaptcha,
            loading: true,
          },
        },
      };
    case 'GENERATE_TRIAL_LOGIN_CG_CAPTCHA#COMPLETE':
      return {
        ...state,
        loginCaptcha: {
          ...state.loginCaptcha,
          cgcaptcha: {
            id: payload.data.id,
            imageUrl: `//${window.CG_CAPTCHA_DOMAIN}${payload.data.image}`,
            loading: false,
          },
        },
      };
    case 'SET_TRIAL_LOGIN_CAPTCHA_TYPE':
      return {
        ...state,
        loginCaptcha: {
          ...state.loginCaptcha,
          captchaType: payload.captchaType,
        },
      };
    case 'TRIAL_SUBMIT_LOGIN#COMPLETE':
      return {
        ...state,
        error: null,
        loading: false,
        RequiredPasswordUpdate: payload.data.RequiredPasswordUpdate,
        RequiredProfileUpdate: payload.data.RequiredProfileUpdate,
      };
    case 'TRIAL_LOGIN_REQUEST_TOTP': {
      return {
        ...state,
        requestTOTP: payload.requestTOTP,
        totpSessionChallenge: payload.challenge || null,
        loading: false,
      };
    }
    case 'RESET_TRIAL_LOGIN_TOTP': {
      return {
        ...state,
        requestTOTP: false,
        totpSessionChallenge: null,
        fields: {
          ...state.fields,
          password: '',
        },
      };
    }
    default:
      return state;
  }
}
